import Colors from '../styles/Colors.json';

// Define the enum for punch types
export enum PunchType {
  FromButton = 1,
  ManualAdd = 2,
  ManualEdit = 3
}

// Define the enum for time entry types
export enum TimeEntryType {
  Regular = 1,
  Meal = 2
}

// Define an enum for the timesheet types
export enum TimesheetType {
  Unsubmitted = "unsubmitted",
  ManagerPending = "managerPending",
  Submitted = "submitted",
  SuperApproved = "superApproved",
  PayApproved = "payApproved"
}

// Function to return punch type color
export const getPunchType = (type: number): string => {
  let punchTypeString = '';

  switch(type) {
    case PunchType.FromButton:
      punchTypeString = Colors.LightBlue;
      break;
    case PunchType.ManualAdd:
      punchTypeString = Colors.Added;
      break;
    case PunchType.ManualEdit:
      punchTypeString = Colors.Edited;
      break;
    default:
      punchTypeString = Colors.RedTransparent70; // Default value if the type doesn't match any case
  }

  return punchTypeString;
};

// Function to return time entry type color
export const getTimeType = (type: number): string => {
  let punchTypeString = '';

  switch(type) {
    case TimeEntryType.Regular:
      punchTypeString = Colors.White;
      break;
    case TimeEntryType.Meal:
      punchTypeString = Colors.Meal;
      break;
    default:
      punchTypeString = Colors.RedTransparent70;
  }

  return punchTypeString;
};
